// extracted by mini-css-extract-plugin
export var bannerContent = "content-module--banner-content--0135f";
export var bannerImage = "content-module--banner-image--ee846";
export var bannerSection = "content-module--banner-section--62bc6";
export var bgBanner = "content-module--bg-banner--5824d";
export var btn = "content-module--btn--17c88";
export var contentImageTransparent = "content-module--content-image-transparent--132e5";
export var contentQuote = "content-module--content-quote--32061";
export var contentSection = "content-module--content-section--9b6d6";
export var fontSizeSmall = "content-module--font-size-small--28667";
export var fullWidthLogos = "content-module--full-width-logos--76507";
export var gridContact = "content-module--grid-contact--85042";
export var gridContactImg = "content-module--grid-contact-img--93c91";
export var gridContactImgWrapper = "content-module--grid-contact-img-wrapper--7b2ba";
export var gridContactName = "content-module--grid-contact-name--18a37";
export var gridContent = "content-module--grid-content--2656e";
export var gridContentImg = "content-module--grid-content-img--edfde";
export var gridContentLogos = "content-module--grid-content-logos--02140";
export var gridContentText = "content-module--grid-content-text--eca40";
export var h1 = "content-module--h1--f1e85";
export var h2 = "content-module--h2--d5069";
export var h3 = "content-module--h3--3f319";
export var h4 = "content-module--h4--6ff1a";
export var h5 = "content-module--h5--305d5";
export var h6 = "content-module--h6--fc24c";
export var imageBanner = "content-module--image-banner--ed916";
export var partnersFullWidth = "content-module--partners-full-width--812c9";